import React, { useState } from "react";
import LiveAuctionCarDetailDealer from "../components/LiveAuction/LiveAuctionCarDetaill";
import { LiveAuctionCarDetail } from "@common/pages/Dashboard/components/LiveAuction/LiveAuctionCarDetaill";
import LiveAuctionCarsList from "../components/LiveAuction/LiveAuctionCarsList";
import { useLocation, useNavigate } from "react-router-dom";
import { routes } from "../../../utils/constants/routes";
// import LiveAuctionCarDetailSeller from "../components/LiveAuction/LiveAuctionCarDetailSeller";
import { useLogPageVisitMutation } from "@common/toolkit/appConfiguration/appConfigurationApi.js";

const LiveAuctionCars = () => {

  // useNavigate...
  const navigate = useNavigate();
  // useNavigate...

  // useLocation...
  const location = useLocation();
  // useLocation...

  // useState variables start...
  const [detailView, setDetailView] = useState(false);
  const [selectedCar, setSelectedCar] = React.useState(null);
  const [myCarsOrOtherCars, setMyCarsOrOtherCars] = React.useState(null);
  // useState variables end...

  const [logPageVisitApiHandler, logPageVisitApiData] = useLogPageVisitMutation();

  const Vehicle_Id = location?.pathname?.split?.(`${routes.liveAuction}/`)?.[1];

  React.useEffect(() => {
    if (myCarsOrOtherCars === null) {
      navigate(`${routes.dashboardNavigation}${routes.liveAuction}`);
    }
  }, [myCarsOrOtherCars]);

  React.useEffect(() => {
    (async () => {
      await logPageVisitApiHandler({
        payload: {
          page_id: 2
        }
      });
    })();
  }, []);

  console.log(Vehicle_Id, myCarsOrOtherCars === 0, "LiveAuction");

  if (Vehicle_Id && myCarsOrOtherCars !== null) {
    if (myCarsOrOtherCars === 0) {
      console.log(`here`);
      return <LiveAuctionCarDetail />
    } else {
      return <LiveAuctionCarDetailDealer 
        selectedCar={selectedCar}
        setSelectedCar={setSelectedCar}
      />;
    }
  }
  return <LiveAuctionCarsList 
    selectedCar={selectedCar}
    setSelectedCar={setSelectedCar}
    onCarClick={(car) => {
      setSelectedCar(car);
      setDetailView(true);
      navigate(`${routes.dashboardNavigation}${routes.liveAuction}/${car?.Vehicle_Id}`);
    }}
    onMyCarsOrOtherCars={(value) => {
      setMyCarsOrOtherCars(value);
    }}
  />;
};

export default LiveAuctionCars;
